import * as account from "../../lib/api/account";
import * as sessionActions from "../../actions/sessionActions";
import config from "../../config.json";
import Loader from "../Loader";
import logger from "../../lib/logger";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { css, StyleSheet } from "aphrodite";
import {
    Label,
    Grid,
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel,
    Button,
} from "react-bootstrap";

const strings = {
    login: "Habit Login",
    username: "Username",
    password: "Password",
    submit: "Submit",
    invalidLogin: "Invalid username or password",
    ssoLoginLink: "Yum SSO Login",
};

const styles = StyleSheet.create({
    ssoRow: {
        marginTop: "16px",
    },
});

const yumSsoUrl = config.yumSsoUrl;

class LoginPage extends PureComponent {
    static propTypes = {
        storeAndSignIn: PropTypes.func.isRequired,
    };
    
    state = {
        loading: false,
        errorMessage: "",
        username: "",
        password: "",
    };

    _handleUsernameChange = e => {
        this.setState({
            username: e.target.value,
        });
    };

    _handlePasswordChange = e => {
        this.setState({
            password: e.target.value,
        });
    };

    _login = e => {
        if (e) {
            e.preventDefault();
        }

        if (this.state.loading) {
            return;
        }

        this.setState({ loading: true });
        account
            .login(this.state.username, this.state.password)
            .then(data => {
                this.setState({ loading: false });
                return this.props.storeAndSignIn(data);
            })
            .catch(err => {
                if (err.response && err.response.status === 400) {
                    this.setState({ loading: false, errorMessage: strings.invalidLogin });
                } else {
                    logger.warn(err);
                    this.setState({ loading: false });
                }
            });
    };

    render() {
        return (
            <Grid>
                <Row>
                    <Col>
                        <h2>{strings.login}</h2>
                    </Col>
                </Row>
                {this.state.errorMessage ? (
                    <Row>
                        <Col md={6}>
                            <Label bsStyle="danger">{this.state.errorMessage}</Label>
                        </Col>
                    </Row>
                ) : null}
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>{strings.username}</ControlLabel>
                            <FormControl
                                type="text"
                                value={this.state.username}
                                onChange={this._handleUsernameChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>{strings.password}</ControlLabel>
                            <FormControl
                                type="password"
                                value={this.state.password}
                                onChange={this._handlePasswordChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        {this.state.loading ? (
                            <Loader />
                        ) : (
                            <Button bsStyle="primary" onClick={this._login}>
                                {strings.submit}
                            </Button>
                        )}
                    </Col>
                </Row>
                {yumSsoUrl ? 
                (
                    <Row className={css(styles.ssoRow)}>
                        <Col md={4}>
                            <a href={yumSsoUrl}>{strings.ssoLoginLink}</a>
                        </Col>
                    </Row>
                )
                : null}
            </Grid>
        );
    }
}

export default connect(null, sessionActions)(LoginPage);